//const { listenerCount } = require("gulp");



jQuery(document).ready(function ($) {

    $("#masthead").attr("tabindex","-1")
  
    $('#responsive-menu-pro-button').attr('aria-label','תפריט');
    $('#responsive-menu-pro-button').attr("aria-expanded","false");

    $('#responsive-menu-pro-button').on("click",function(event){


        if ($(this).attr("aria-expanded") == "true" ){

           
            $(this).attr("aria-expanded","false");

        }else{
          
            $(this).attr("aria-expanded","true");
        }

       
    })



    $("#responsive-menu-pro>li.menu-item>a.responsive-menu-pro-item-link").each(function(){

        var hasSubMenu = $(this).parent().find(".responsive-menu-pro-submenu");

      
        if( hasSubMenu.length ){
            if($(hasSubMenu).hasClass('responsive-menu-pro-submenu-open')){
                $(this).attr("aria-expanded","true");
            }else{
                $(this).attr("aria-expanded","false");
            }
           
            $(this).on('click',function(){

                var expanded = $(this).attr("aria-expanded")
                if (expanded == "true"){
                    $(this).attr("aria-expanded","false");
                }else{
                    $(this).attr("aria-expanded","true");
                }


            })

        }

    });

 


    $(".main-navigation li.menu-item-has-children>a").attr("role","button");
    $(".main-navigation li.menu-item-has-children>a").attr("tabindex","0");
    $(".main-navigation li.menu-item-has-children>a").attr("aria-expanded","false");


    $(".main-navigation li.menu-item-has-children>a").on("click keypress",function(event){
        if(a11yClick(event)===true){
       
            if(event.type === 'keypress'){
                jQuery(this).trigger('click');
                return;
            }

            if ($(this).parent().hasClass('open')){

                $(this).parent().removeClass('open');
                $(this).attr("aria-expanded","false");

            }else{
                $(this).parent().addClass('open');
                $(this).attr("aria-expanded","true");
            }
        }

        /*event.preventDefault();*/
    })


    $("a.generate-back-to-top").on("click keypress",function(event){
      
        if(a11yClick(event)===true){
       
            if(event.type === 'keypress'){
                $(this).trigger('click');
                return;
            }

            setTimeout(function(){   
                
               
                $("#masthead").focus(); }
                ,450)
          
            
        }
    });

    $('.hp-image-boxes .elementor-image-box-img a').attr("tabindex","-1");
    $('.hp-image-boxes .elementor-image-box-img a').attr("aria-hidden","true");

    $('.a2a_kit .a2a_button_facebook .a2a_label').text("שתף את העמוד בפייסבוק");
    $('.a2a_kit .a2a_button_whatsapp .a2a_label').text("שתף את העמוד בוואטצאפ");
    $('.a2a_kit .a2a_button_email .a2a_label').text("שתף את העמוד במייל");


    //category / blog page

    if ($("body").hasClass("archive")){
        $("article .inside-article .post-image a").attr("aria-hidden","true");
        $("article .inside-article .post-image a").attr("tabindex","-1");
       // $("article .inside-article .post-image a img").attr("alt","");

        $("article .inside-article .entry-header").removeAttr("aria-label");
        $("article .inside-article .entry-meta").removeAttr("aria-label");
    }


    /** breadcrumbs **/

    var breadcrumbs= $('p#breadcrumbs');

    $(breadcrumbs).attr('aria-label','breadcrumbs');
    $(breadcrumbs).attr('role','list');
    $('p#breadcrumbs>span>span:not(:last-child)').attr('role','listitem')

    var theCrumbs = $('p#breadcrumbs span').html();
    var crumbsArray = theCrumbs.split("&gt;") ;

    theCrumb = crumbsArray.join( '<span aria-hidden="true"> &gt; </span>')


    $('p#breadcrumbs span').html(theCrumb);  


    $("a.has-chaty-box.chaty-whatsapp-form").attr("role","button");
    $("a.has-chaty-box.chaty-whatsapp-form").attr("aria-haspopup","dialog");
    

}); // end of load

